import { Progress as AntProgress } from 'antd';
import styled from 'styled-components';
import { Color } from '../../config/Color';

export const Progress = styled(AntProgress)`
  width: 100%;
  max-width: 100%;

  .ant-progress-success-bg,
  .ant-progress-bg {
    background-color: ${Color.flow.accent};
  }
  .ant-progress-inner {
    background-color: ${Color.decorative.muted};
  }
`;
